import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import WithRender from './pagination.tpl.html';

@WithRender
@Component
export default class Pagination extends Vue {

    @Prop({
        required: true,
        type: Number
    })
    limit: number;

    @Prop({
        required: true,
        type: Number
    })
    offset: number;

    @Prop({
        required: true,
        type: Number
    })
    total: number;

    /**
     * When true this display a list of buttons with page numbers instead of just arrow buttons
     */
    @Prop({
        default: false,
        type: Boolean
    })
    pageButtons: boolean;

    /**
     * A selection dialog for the amount of items on a page
     */
    @Prop({
        default: false,
        type: Boolean
    })
    pageCount: boolean;

    /**
     * The amount of buttons that show pages after the current one
     */
    @Prop({
        default: 2,
        type: Number
    })
    buttonsAhead: number;

    /**
     * The amount of buttons that show pages before the current one
     */
    @Prop({
        default: 2,
        type: Number
    })
    buttonsBack: number;

    updatedLimit: number = 40;

    get showPrevious(){
        return this.offset > 0;
    }

    get showNext(){
        return this.total > (this.offset + this.limit);
    }

    get currentPage(){
        return (this.offset / this.limit) + 1;
    }

    get totalPages(){
        return Math.ceil(this.total / this.limit);
    }

    get pages(){
        const pages = [];

        const indexStart = this.currentPage - this.buttonsBack;
        const indexEnd = this.currentPage + this.buttonsAhead;

        for(var page = indexStart; page <= indexEnd; page++){
            if(page < 1 || page > this.totalPages){
                continue;
            }

            pages.push(page);
        }

        return pages;
    }

    next(){
        this.$emit('update:offset', this.offset + this.limit);
        this.$emit('pageChange');
    }

    previous(){
        this.$emit('update:offset', this.offset - this.limit);
        this.$emit('pageChange');
    }

    setPage(page: number){
        this.$emit('update:offset', (page - 1) * this.limit);
        this.$emit('pageChange');
    }

    @Watch('updatedLimit')
    onUpdatedLimitChange(limit: any){
        const currentPage = Math.floor((this.offset / limit));

        this.$emit('update:limit', parseInt(limit));
        this.$emit('update:offset', currentPage * limit);
        this.$emit('pageChange');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./node_modules/sensejs/vue/components/pagination/index.ts